import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem, CartState } from "src/types/cartTypes";
const initialState: CartState = {
  items: [],
  loading: false,
  error: null,
  type: "default",
  totalQuantity: 0,
  totalPrice: 0,
  currency: "CAD",
  tax: [],
  discount: 0,
  couponError: null,
  refreshCart: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    getCart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getCartSuccess: (state, action: PayloadAction<any>) => {
      state.items = action.payload.items;
      state.totalQuantity = action.payload.totalQuantity;
      state.totalPrice = action.payload.totalPrice;
      state.discount = action.payload.discount;
      state.couponCode = action.payload.couponCode;
      state.currency = "CAD";
      state.loading = false;
      state.error = null;
      state.couponError = null;
    },
    getCartFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addItem: (state, action: PayloadAction<CartItem>) => {
      state.loading = true;
      state.error = null;
    },
    addItemSuccess: (state, action: PayloadAction<CartItem>) => {
      state.items.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    addItemFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = null;
    },
    removeItem: (state, action: PayloadAction<number>) => {
      state.loading = true;
      state.error = null;
    },
    updateItems: (state, action: PayloadAction<CartState>) => {
      state.items = action.payload.items;
      state.totalQuantity = action.payload.totalQuantity;
      state.totalPrice = action.payload.totalPrice;
      state.discount = action.payload.discount;
      state.couponCode = action.payload.couponCode;
      state.currency = "CAD";
      state.loading = false;
      state.error = null;
      state.couponError = null;
    },
    addNewItem: (state, action: PayloadAction<CartItem>) => {
      state.items.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.totalPrice = 0;
      state.currency = "CAD";
      state.loading = false;
      state.error = null;
    },
    clearCartAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateItemQuantity: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    getTax: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    getTaxSuccess: (state, action: PayloadAction<any>) => {
      state.tax = action.payload;
      state.loading = false;
      state.error = null;
    },
    getTaxFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    createReOrder: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },
    addCouponCode: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },
    addCouponCodeFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.couponError = action.payload;
    },
    clearCouponErrorMessage: (state) => {
      state.couponError = null;
    },
    refreshCart: (state) => {
      state.refreshCart = !state.refreshCart;
    },
  },
});

export const {
  addItem,
  addNewItem,
  updateItems,
  removeItem,
  updateItemQuantity,
  getTax,
  getTaxSuccess,
  getTaxFailure,
  clearCart,
  clearCartAction,
  createReOrder,
  addCouponCode,
  addCouponCodeFailure,
  getCart,
  getCartSuccess,
  getCartFailure,
  clearCouponErrorMessage,
  refreshCart,
} = cartSlice.actions;
export default cartSlice.reducer;
